import { render } from "./Wall2View.vue?vue&type=template&id=6e1e4657&scoped=true"
const script = {}

import "./Wall2View.vue?vue&type=style&index=0&id=6e1e4657&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e1e4657"]])

export default __exports__